module.exports = __webpack_public_path__ + "static/scale-model-of-meadowlark-theater-in-omaha-nebraska-28d14d6c5d22c62dea16893a68d47fca.png";